"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonalGeneralSettings = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SettingsItem = _interopRequireDefault(require("../Settings/components/SettingsItem/SettingsItem"));

var _NameSetting = _interopRequireDefault(require("./components/NameSetting/NameSetting"));

var _AvatarSetting = _interopRequireDefault(require("./components/AvatarSetting/AvatarSetting"));

var _RoleSetting = _interopRequireDefault(require("./components/RoleSetting/RoleSetting"));

var _PhoneSetting = _interopRequireDefault(require("./components/PhoneSetting/PhoneSetting"));

var _FunFactsSetting = _interopRequireDefault(require("./components/FunFactsSetting/FunFactsSetting"));

var actions = _interopRequireWildcard(require("./store/personalGeneralSettings/personalGeneralSettings.actions"));

var selectors = _interopRequireWildcard(require("./store/personalGeneralSettings/personalGeneralSettings.selector"));

var PersonalGeneralSettings = function PersonalGeneralSettings(_ref) {
  var companyName = _ref.companyName;
  var dispatch = (0, _reactRedux.useDispatch)();
  var errors = (0, _reactRedux.useSelector)(selectors.getErrors);
  var isLoading = (0, _reactRedux.useSelector)(selectors.getIsLoading);
  var firstName = (0, _reactRedux.useSelector)(selectors.getFirstName);
  var lastName = (0, _reactRedux.useSelector)(selectors.getLastName);
  var phone = (0, _reactRedux.useSelector)(selectors.getPhone);
  var role = (0, _reactRedux.useSelector)(selectors.getRole);
  var avatarUrl = (0, _reactRedux.useSelector)(selectors.getAvatarUrl);
  var funFacts = (0, _reactRedux.useSelector)(selectors.getFunFacts);
  var isFanFactsVisible = (0, _reactRedux.useSelector)(selectors.getIsFunFactsVisible);
  var handleRemoveAvatar = (0, _react.useCallback)(function () {
    return dispatch(actions.deleteAvatar());
  }, [dispatch]);
  var handleUploadAvatar = (0, _react.useCallback)(function (file) {
    return dispatch(actions.setAvatar(file));
  }, [dispatch]);
  var handleSaveName = (0, _react.useCallback)(function (_ref2) {
    var newFirstName = _ref2.firstName,
        newLastName = _ref2.lastName;
    return dispatch(actions.setName({
      firstName: newFirstName,
      lastName: newLastName
    }));
  }, [dispatch]);
  var handleSaveRole = (0, _react.useCallback)(function (newRole) {
    return dispatch(actions.setRole(newRole));
  }, [dispatch]);
  var handleSavePhone = (0, _react.useCallback)(function (newPhone) {
    return dispatch(actions.setPhone(newPhone));
  }, [dispatch]);
  var handleFunFactsSave = (0, _react.useCallback)(function (data) {
    return dispatch(actions.setFunFacts(data));
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    dispatch(actions.getSettings());
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AvatarSetting.default, {
    isLoading: isLoading,
    alt: "".concat(firstName, " ").concat(lastName),
    image: avatarUrl,
    onRemove: handleRemoveAvatar,
    onUpload: handleUploadAvatar
  }), /*#__PURE__*/_react.default.createElement(_SettingsItem.default, {
    title: "Display Name",
    description: "This is how your name will be displayed across site, emails, etc. Your display name is currently set to",
    isLoading: isLoading,
    value: "".concat(firstName, " ").concat(lastName)
  }, /*#__PURE__*/_react.default.createElement(_NameSetting.default, {
    firstName: firstName,
    lastName: lastName,
    errors: errors,
    onSave: handleSaveName,
    isLoading: isLoading
  })), /*#__PURE__*/_react.default.createElement(_SettingsItem.default, {
    title: "Your role",
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "This will display your current role at ", /*#__PURE__*/_react.default.createElement("strong", null, companyName), " in all of your Alyce email signatures. Your role is currently set to"),
    isLoading: isLoading,
    value: role
  }, /*#__PURE__*/_react.default.createElement(_RoleSetting.default, {
    role: role,
    onSave: handleSaveRole,
    isLoading: isLoading,
    errors: errors
  })), /*#__PURE__*/_react.default.createElement(_SettingsItem.default, {
    title: "Phone number",
    description: "When sending a gift, you can append your phone number to your Alyce email signature and gift landing page. Your phone number is currently set to",
    isLoading: isLoading,
    value: phone || 'None'
  }, /*#__PURE__*/_react.default.createElement(_PhoneSetting.default, {
    onSave: handleSavePhone,
    phone: phone,
    isLoading: isLoading,
    errors: errors
  })), /*#__PURE__*/_react.default.createElement(_SettingsItem.default, {
    title: "Your fun fact(s)",
    description: "Let your recipients know a little about yourself. Your fun fact is currently set to",
    isLoading: isLoading,
    value: isFanFactsVisible ? 'Display in gift experience landing pages' : 'Hide'
  }, /*#__PURE__*/_react.default.createElement(_FunFactsSetting.default, {
    onSave: handleFunFactsSave,
    showFunFacts: isFanFactsVisible,
    funFacts: funFacts,
    isLoading: isLoading,
    errors: errors
  })));
};

exports.PersonalGeneralSettings = PersonalGeneralSettings;
PersonalGeneralSettings.propTypes = {
  companyName: _propTypes.default.string
};
PersonalGeneralSettings.defaultProps = {
  companyName: ''
};

var _default = /*#__PURE__*/(0, _react.memo)(PersonalGeneralSettings);

exports.default = _default;